import APIController from 'api/core-api-controller';

export const fetchIntakeDataApi = ({
  params = {},
  intakeId = '',
  token = process.env.REACT_APP_EXTERNAL_AUTH_TOKEN,
}) => {
  const path = `${APIController.endpointApi}/external/intakes/${intakeId}`;
  return APIController.getExternalApiCalllback(path, params, null, token);
};

export const submitIntakeAnswersApi = ({
  data = {},
  intakeId = '',
  token = process.env.REACT_APP_EXTERNAL_AUTH_TOKEN,
}) => {
  const path = `${APIController.endpointApi}/external/intakes/${intakeId}/submit_answers`;
  return APIController.postExternalCallback(path, data, false, token);
};

export const fetchIntakeOptionsApi = ({ path = '', token = process.env.REACT_APP_EXTERNAL_AUTH_TOKEN }) => {
  const fullPath = `${APIController.endpointApi}/${path}`;
  return APIController.getExternalApiCalllback(fullPath, {}, null, token);
};

export const fetchAvailableLabPanelsApi = ({ intakeId = '', token = process.env.REACT_APP_EXTERNAL_AUTH_TOKEN }) => {
  const path = `${APIController.endpointApi}/external/intakes/${intakeId}/fetch_available_panel`;
  return APIController.getExternalApiCalllback(path, {}, null, token);
};

export const generateIntakeLabOrderApi = ({
  data = {},
  intakeId = '',
  token = process.env.REACT_APP_EXTERNAL_AUTH_TOKEN,
}) => {
  const path = `${APIController.endpointApi}/external/intakes/${intakeId}/generate_intake_lab_order`;
  return APIController.postExternalCallback(path, data, false, token);
};

export const downloadLabOrderPdf = ({
  orderId = '',
  token = process.env.REACT_APP_EXTERNAL_AUTH_TOKEN,
  query = '',
}) => {
  const path = `${APIController.endpointApi}/external/lab_orders/${orderId}/download_pdf${query ? query : ''}`;
  return APIController.getExternalApiCalllback(path, {}, null, token);
};

export const updateLabFieldsApi = ({ intakeId = '', data = {}, token = process.env.REACT_APP_EXTERNAL_AUTH_TOKEN }) => {
  const path = `${APIController.endpointApi}/external/intakes/${intakeId}/update_lab_fields`;
  return APIController.postExternalCallback(path, data, false, token);
};

export const fetchIntakeApi = (id) => {
  const path = `${APIController.endpointApi}/intakes/${id}`;
  return APIController.getApiCallback(path);
};

export const syncIntakeApi = (id) => {
  const path = `${APIController.endpointApi}/intakes/${id}/sync`;
  return APIController.postCallback(path);
};

export const updateIntakeSubmittedAnswersApi = ({ id = '', data = {} }) => {
  const path = `${APIController.endpointApi}/intakes/${id}/submit_answers`;
  return APIController.postCallback(path, data);
};

export const resyncIntakeFormAnswersApi = (id) => {
  const path = `${APIController.endpointApi}/intakes/${id}/resync_form_answers`;
  return APIController.postCallback(path);
};
